<!-- eslint-disable no-unused-vars -->
<template>
  <div class="content-container">
    <!-- Search Component -->
    <search-comp :search-show="true" @onSearch="attachData" @onReset="onReset">
      <template>
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row align-end">
              <div class="das-form-col col-3">
                <div class="das-form-input">
                  <div class="label">Đoàn</div>
                  <input v-model="searchParams.customerInfo" type="text" />
                  <!-- <select-with-search-table
                    style="width: 100%"
                    :rows="checkoutGroupOptions"
                    :dropdown-width="400"
                    :columns="selectSearchCol1"
                    :search-fields="['group_name']"
                    :value="groupCheckoutId"
                    :selected-index-field-value="groupCheckoutId"
                    index-field="id"
                    @selectionChanged="onSelectRowOption"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      {{ selectedData?.group_name }}
                    </template>
                  </select-with-search-table> -->
                </div>
              </div>
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <div class="label">Ngày</div>
                  <CalendarRange
                    v-model="arrivePeriod"
                    style="display: block; width: 100%"
                    mode="date"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </search-comp>
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        dom-layout="scroll"
        :auto-select-first-row="false"
        :rows="rows"
        class="agGrid"
        @rowClicked="onRowClicked"
      />
    </div>
    <div class="button-containers mb-0">
      <button class="btn primary small">
        {{ $t('button.downloadExcel') }}
      </button>
    </div>
    <!--  -->
  </div>
</template>

<script>
// eslint-disable-next-line
import {
  getCheckoutGroup,
  // eslint-disable-next-line no-unused-vars
  getCancelNoShowList
} from '@/api/cashier_service/cancel-not-show'
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
  },
  data() {
    return {
      arrivePeriod: {},
      searchParams: {
        customerInfo: null,
        dateFrom: null,
        dateTo: null
      },
      loading: false,
      isEdit: false,
      dialogFormVisible: false,
      groupCheckoutId: null,
      checkoutGroupOptions: [],
      item: {
        booking_code: null,
        sub_booking_code: null,
        id: null
        // code: null,
        // desc: null
      },
      columns: [
        // {
        //   headerName: '',
        //   field: 'index',
        //   minWidth: 60,
        //   maxWidth: 60,
        //   headerCheckboxSelection: true,
        //   headerCheckboxSelectionFilteredOnly: true,
        //   checkboxSelection: true,
        //   resizable: false
        // },
        {
          headerName: 'Tên khách',
          field: 'guest_name',
          tooltipField: 'guest_name'
        },
        {
          headerName: 'Mã đặt phòng',
          field: 'room_booking_code',
          tooltipField: 'room_booking_code'
        },
        {
          headerName: 'Ngày đến',
          field: 'arrive_date',
          valueGetter: param => {
            return this.$displayDate(param?.data?.arrive_date) ?? null
          },
          tooltipValueGetter: param => {
            return this.$displayDate(param?.data?.arrive_date) ?? null
          }
        },
        {
          headerName: 'Ngày đi',
          field: 'depart_date',
          valueGetter: param => {
            return this.$displayDate(param?.data?.depart_date) ?? null
          },
          tooltipValueGetter: param => {
            return this.$displayDate(param?.data?.depart_date) ?? null
          }
        },
        {
          headerName: 'Lý do hủy',
          field: 'cancel_reason',
          tooltipField: 'cancel_reason'
        },
        {
          headerName: 'Số tiền',
          field: 'amount_money',
          valueGetter: params => {
            return this.$displayCurrency(params?.data?.amount_money) ?? 0
          }
        },
        {
          headerName: this.$t('grid.column.customerLevel'),
          field: 'level_guest',
          tooltipField: 'level_guest'
        },
        {
          headerName: this.$t('grid.column.roomNumber'),
          field: 'room_num',
          tooltipField: 'room_num'
        },
        {
          headerName: this.$t('grid.column.roomLevel'),
          field: 'room_level',
          tooltipField: 'room_level'
        }
        // {
        //   headerName: this.$t('grid.column.comeDate'),
        //   field: 'arrive_date'
        // }
        // {
        //   headerName: this.$t('grid.column.dateTo'),
        //   field: 'depart_date'
        // }
      ],
      selectSearchCol1: [
        {
          headerName: 'Mã nhóm',
          field: 'group_code'
        },
        {
          headerName: 'Tên nhóm',
          field: 'group_name'
        },
        {
          headerName: 'Tên công ty',
          field: 'agent_name'
        }
      ],
      rows: [
        {
          sub_booking_code: 'Test data',
          master: true,
          confirm_code: '12345',
          booking_code: '45678',
          last_name: 'Ngô',
          first_name: 'Trường',
          customer_level: 'customer_level',
          room_num: '6565',
          room_level: '2',
          depart_date: '2023/12/12',
          name: 'Mr',
          gender: 1
        }
      ]
    }
  },
  watch: {
    arrivePeriod(data) {
      this.searchParams.dateFrom = data.start || null
      this.searchParams.dateTo = data.end || null
    },
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetInfo()
    }
  },
  async mounted() {
    await this.getcheckoutGroupOptions()
    this.attachData()
  },
  methods: {
    onReset() {
      this.$nullValueInObj(this.searchParams)
      this.arrivePeriod = {}
      this.attachData()
    },
    // onRowClicked() {
    //   const gridApi = this.$refs.agGrid.gridApi
    //   const row = gridApi.getSelectedRows()[0]
    //   Object.assign(this.item, row)
    // },
    async getcheckoutGroupOptions() {
      await getCheckoutGroup()
        .then(async res => {
          const data = res.data
          this.checkoutGroupOptions = data ?? []
          // const message = res.message
          // this.$message({
          //   type: 'success',
          //   message: this.$t(`successMsg.${message}`)
          // })
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          // const message = error.response?.data?.message || 'default'
          // this.$message({
          //   type: 'error',
          //   message: this.$t(`errorMsg.${message}`)
          // })
        })
    },
    async attachData() {
      // await getCode(this.item).then(res => {
      //   this.rows = res.data
      // })
      const data = await getCancelNoShowList(this.searchParams)
      this.rows = data?.data || []
    }
  }
}
</script>

<style lang="scss"></style>
